import {
  ITransform,
  parseNumber,
  parseString,
  transformModel,
} from '~/src/dash/api/resource-transforms';
import {
  addDomainAndTokenToUrl,
  IHttpResponse,
  restDelete,
  restGet,
  restPost,
} from '~/src/dash/api/rest';

export interface IIPTrace {
  ID: number;

  PublisherID: string;
  UserID: string;
  UUID: string;
  IP: string;
  Email: string;
  Status: number;

  // Only EndDate is stored in db, we calculate the timeframe on the ui and display it to the user.
  // When create/update IPTrace record, we calclute the end_date based on the tieframe user chooses.
  StartDate: string;
  EndDate: string;
  TimeFrame?: string;
}

// |------------------ IPTrace Transformations ------------------|
const transformIPTracesConfig: ITransform = {
  IP: parseString(['IP']),
  Email: parseString(['Email']),
};

const transformIPTraceToApiConfig: ITransform = Object.assign({}, transformIPTracesConfig, {
  PublisherID: parseNumber(['PublisherID']),
  UserID: parseNumber(['UserID']),
});

const transformIPTraceFromApiConfig: ITransform = Object.assign({}, transformIPTracesConfig, {
  ID: parseNumber(['ID']),
  UUID: parseString(['UUID']),
  PublisherID: parseString(['PublisherID']),
  UserID: parseString(['UserID']),
  StartDate: parseString(['StartDate']),
  EndDate: parseString(['EndDate']),
});

export const transformIPTraceToApi = transformModel<IIPTrace>(transformIPTraceToApiConfig);
export const transformIPTraceFromApi = transformModel<IIPTrace>(transformIPTraceFromApiConfig);

// |------------------ IPTrace API CALLS ------------------|

// GET all ip traces for this publisher
// /publishers/{publisherID}/ip_traces
export async function getIPTraces(publisherID: string): Promise<IIPTrace[]> {
  const reqUrl = addDomainAndTokenToUrl(`/publishers/${publisherID}/ip_traces`);
  return await restGet<IIPTrace[]>(reqUrl, {}).then((val: IHttpResponse<IIPTrace[]>) => {
    return val.parsedBody ? val.parsedBody.map(transformIPTraceFromApi) : [];
  });
}

// DELETE a single IP Trace
// /publishers/{publisherID}/ip_trace/{ipTraceID}
export async function deleteIPTrace(
  ipTraceID: number,
  publisherID: string,
): Promise<IHttpResponse<{ status: boolean }>> {
  const reqUrl = addDomainAndTokenToUrl(`/publishers/${publisherID}/ip_trace/${ipTraceID}`);
  return await restDelete<{ status: boolean }>(reqUrl, undefined);
}

// POST a single IPTrace
// /publishers/{publisherID}/ip_trace
export async function createIPTrace(
  IPTrace: Partial<IIPTrace>,
  publisherID: string,
  timeFrame: string,
): Promise<IIPTrace> {
  const parsedIPTrace = transformIPTraceToApi(IPTrace);
  let reqUrl = addDomainAndTokenToUrl(`/publishers/${publisherID}/ip_trace`);
  reqUrl += `&time_frame=${timeFrame}`;
  return await restPost<IIPTrace>(reqUrl, parsedIPTrace).then((val: IHttpResponse<IIPTrace>) => {
    return transformIPTraceFromApi(val.parsedBody);
  });
}
